module.exports = __webpack_public_path__ + "static/assets/b39c8da3ec94891b76a0b0cb5a4f72a4.svg";